import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';

import Card from '../../elements/common/Card';
import handleValidationErrors, { ValidationErrors } from '../../helpers/ResponseErrorHelper';
import useBlockingSubmit from '../../hooks/useBlockingSubmit';
import useNumberParams from '../../hooks/useNumberParams';
import useOnce from '../../hooks/useOnce';
import useSmartField, { FieldChangeCallback } from '../../hooks/useSmartField';

import { statusCodeOptions } from './CreateCustomRedirect';

import CustomRedirectsApi from 'Api/CRM/Modules/CustomRedirectsApi';
import CustomRedirect from 'Api/Models/CustomRedirect';
import SweetAlert from 'crm/elements/alerts/SweetAlert';

function EditCustomRedirect() {
    const history = useHistory();
    const { id } = useNumberParams();
    const [errors, setErrors] = useState<ValidationErrors>({});
    const [customRedirect, setCustomRedirect] = useState<CustomRedirect>(new CustomRedirect({}));

    useOnce(() => CustomRedirectsApi.getById(id).then(setCustomRedirect));

    const handleFieldChange: FieldChangeCallback = (name, value) =>
        setCustomRedirect((prevArticle) => prevArticle.getNew({ [name]: value }));

    const Field = useSmartField({ errors, onChange: handleFieldChange });
    const [Submit, submitBlocked] = useBlockingSubmit();

    async function handleFormSubmit(event: React.FormEvent<HTMLFormElement>) {
        event.preventDefault();
        try {
            await CustomRedirectsApi.update(customRedirect);
            await SweetAlert.success('Custom redirect updated correctly');
            history.push('/custom-redirects');
        } catch (error) {
            handleValidationErrors(error, setErrors);
            submitBlocked(false);
        }
    }

    return (
        <Card>
            <form onSubmit={handleFormSubmit}>
                <Field name="source_url" value={customRedirect.source_url} required />
                <Field name="target_url" value={customRedirect.target_url} required />
                <Field
                    type="select"
                    name="status_code"
                    value={customRedirect.status_code}
                    required
                    options={statusCodeOptions}
                    onChange={handleFieldChange}
                />
                <Submit label="Update" />
            </form>
        </Card>
    );
}

export default EditCustomRedirect;
